import React from 'react'
import {PageTitle} from '../../../_metronic/layout/core'
import {Navigate, Route, Routes} from 'react-router-dom'
import RemiseListPage from './RemiseListPage'
import RemiseAddPage from './RemiseAddPage'
import RemiseEditPage from './RemiseEditPage'

const RemiseWrapper = () => {
  return (
    <>
      <Routes>
        <Route
          path='/groupe/liste'
          element={
            <>
              <PageTitle breadcrumbs={[
                {
                  title: 'Paramètres',
                  path: '#',
                  isSeparator: false,
                  isActive: true,
                }
              ]}>Remise groupe client</PageTitle>
              <RemiseListPage />
            </>
          }
        />
        <Route
          path='/groupe/ajouter'
          element={
            <>
              <PageTitle breadcrumbs={[
                { title: 'Paramètres', path: '#', isSeparator: false, isActive: false },
                { title: 'Remise groupe client', path: '/remise', isSeparator: false, isActive: true },
              ]}>Création</PageTitle>
              <RemiseAddPage />
            </>
          }
        />
        <Route
          path='/groupe/:remiseId/edit'
          element={
            <>
              <PageTitle breadcrumbs={[
                { title: 'Paramètres', path: '#', isSeparator: false, isActive: false },
                { title: 'Remise groupe client', path: '/remise', isSeparator: false, isActive: true },
              ]}>Modification</PageTitle>
              <RemiseEditPage />
            </>
          }
        />
        <Route index element={<Navigate to='/remise/groupe/liste' />} />
      </Routes>
    </>
  )
}

export default RemiseWrapper
